import { useQueryClient } from 'react-query';
import QUERY_CACHE_KEY from '@constants/QueryCacheKey';
import useApiMutation from './useApiMutation';

export default function useUpdateSurveyMutation(surveyId, options) {
  const queryClient = useQueryClient();

  return useApiMutation('patch', `/v1/surveys/${surveyId}`, {
    ...options,
    onSuccess: async (res, ...args) => {
      // Invalide le cache pour ce sondage et pour le feed
      queryClient.invalidateQueries(QUERY_CACHE_KEY.survey(surveyId), { exact: true });
      queryClient.invalidateQueries(QUERY_CACHE_KEY.feed());
      queryClient.invalidateQueries(QUERY_CACHE_KEY.feedDetailed());
      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(res, ...args);
      }
    },
  });
}
